import { AccountingAreaRoutes } from '@backoffice-frontend/common'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { BookOpenIcon } from '@moia-dev/pace-icons'

export const AccountingAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={AccountingAreaRoutes.route}
      Icon={BookOpenIcon}
    />
  )
}
